// extracted by mini-css-extract-plugin
export default {"socialMediaLinkListOnyx":"socialMediaLinkListOnyx__SSKEV","socialMediaLinkListGrepo":"socialMediaLinkListGrepo__YIxqB","open":"open__sfyuX","closed":"closed__QA_dX","facebook":"facebook__feu1A","instagram":"instagram__cB5qM","twitter":"twitter__HIfIc","discord":"discord___IWKv","youtube":"youtube__UVAmz","transparentBg":"transparentBg__AzMiH","large":"large__aXPvF"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"socialMediaLinkListOnyx\":\"socialMediaLinkListOnyx__SSKEV\",\"socialMediaLinkListGrepo\":\"socialMediaLinkListGrepo__YIxqB\",\"open\":\"open__sfyuX\",\"closed\":\"closed__QA_dX\",\"facebook\":\"facebook__feu1A\",\"instagram\":\"instagram__cB5qM\",\"twitter\":\"twitter__HIfIc\",\"discord\":\"discord___IWKv\",\"youtube\":\"youtube__UVAmz\",\"transparentBg\":\"transparentBg__AzMiH\",\"large\":\"large__aXPvF\"}";
        // 1787130557195
        var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  